import './styles.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { AuthProvider } from './auth/AuthProvider';
import { BetaRibbon } from './components/BetaRibbon';

/**
 * Bootstrap della SPA.
 * Provider previsti dal design del frontend:
 *  - BrowserRouter (React Router) per il routing per ruolo
 *  - QueryClientProvider (TanStack Query) per il server-state con invalidazione
 *  - AuthProvider (OIDC PKCE) per lo stato di autenticazione (user, role, login/logout)
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Elemento #root non trovato in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <BetaRibbon />
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
